<template>
  <mini-card :value="$store.getters.totalLeads" :subtitle="'Leads Received'"
              :previousValue="$store.getters.totalLeadsPrevious">
    <div slot="header" class="icon-warning">
      <i class="fad fa-inbox-in text-success"></i>
    </div>
    <template slot="footer">
      <div class="row small">
        <a class="ml-3 mr-auto" href="#" @click="addLead()"><i class="fas fa-plus mr-1"/>lead</a>
        <!-- <a class="mr-3" href="#" @click="viewLeads()"><i class="far fa-eye mr-1"/>all leads</a> -->
      </div>
    </template>
  </mini-card>
</template>

<script>
import MiniCard from './MiniCard.vue'
import {Lead} from 'src/classes/datamodel.js'
export default {
  name: 'Leads-Received-MiniCard',
  components: {
    MiniCard
  },
  methods: {
    addLead () {
      this.$store.dispatch('openModal', {name: 'Lead',
                                         mode: 'Create',
                                         object: new Lead({status: Lead._status.RECEIVED.value})})
    },
  }
}
</script>

<style>

</style>